export default "__VITE_ASSET__88acfa6c__"